import { forwardRef, type ButtonHTMLAttributes } from "react";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "destructive";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant = "secondary", type = "button", ...properties },
  reference,
) {
  const classes = ["button", `button-${variant}`, className].filter(Boolean).join(" ");
  return <button {...properties} className={classes} ref={reference} type={type} />;
});
